import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import store from './states/store';
import ScrollToTop from './utils/scrollToTop';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom/dist'
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <SpeedInsights />
        <Analytics />
        <ScrollToTop />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

